import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../../../helpers/reselectHelpers';
import {getCompanyUrl} from '../../../../../../store/data/company/companySelectors';
import {updateTopicNameAsyncAction} from '../../../../../../store/data/conversations/topicConversationsActions';
import {AddOrEditTopicDialog} from './addOrEditTopicDialog';

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  companyUrl: getCompanyUrl,
}));

const dispatchProps = {
  updateTopicName: updateTopicNameAsyncAction,
};

export const AddOrEditTopicDialogContainer = connect(mapStateToProps, dispatchProps)(AddOrEditTopicDialog);
